var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 98",
    width: 98,
    height: 98,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-149-1579h1366v3181h-1366z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#548aff}.b{fill:#ffb401}.c{fill:#4976f2}.d{fill:#7dafff}.e{fill:#ffc431}.f{fill:#ffa100}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m77.6 23.3v74.2h-70.2c-3.7 0-6.7-3-6.7-6.7v-83.6c0-3.7 3-6.7 6.7-6.7h47.4c1.8 0 3.5 0.7 4.7 1.9l16.2 16.2c1.2 1.2 1.9 2.9 1.9 4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m57.6 28.9c0 3.3 0.6 6.6 1.8 9.7l1.5 3.7v3.3h16.7v-3.3l1.5-3.7c1.3-3.1 1.9-6.4 1.9-9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m10.7 12.2h5.1v3.3h-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m19.1 12.2h11.7v3.3h-11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m77 20.5h-12.7c-3.7 0-6.7-3-6.7-6.7v-12.7q1.1 0.5 1.9 1.3l16.2 16.2q0.8 0.8 1.3 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m10.7 87.4h6.7v3.4h-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m20.8 87.4h6.7v3.4h-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m25.8 23.9v6.7h28.4v3.3h-8.3v10h-20.1v25.1h13.4v3.4h-13.4v6.7h13.4v3.3h-28.5c-0.9 0-1.6-0.7-1.6-1.7v-58.5c0-0.9 0.7-1.7 1.6-1.7h43.5v3.4zm-3.3 48.5h-10.1v6.7h10.1zm0-28.5h-10.1v25.1h10.1zm3.3-10v6.7h16.7v-6.7zm-3.3-10h-10v16.7h10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m40.8 97.5v-4.4c0-1.5 0.6-2.9 1.7-4l1.7-1.7v-25.1c0-11 9-20 20.1-20h10c11.1 0 20.1 9 20.1 20v25.1l1.6 1.7c1.1 1.1 1.7 2.5 1.7 4v4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m71.7 69h-3.4c-1.3 0-2.5-1.1-2.5-2.5 0-1.4 1.2-2.5 2.5-2.5h6.7v-3.3h-3.3v-3.4h-3.4v3.4c-3.2 0-5.8 2.6-5.8 5.8 0 3.3 2.6 5.9 5.8 5.9h3.4c1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5h-8.4v3.3h5v2.7h3.4v-2.7c3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.6-5.9-5.8-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m86 84.1h8.4v3.3h-8.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.6215504ff45db1d9cd067de63ace3ffe.svg";
export { ForwardRef as ReactComponent };